import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import EventDetail from "../../../Components/EventMgt/CreateEvent/EventDetail";
import Layout from "../../../Components/Layout";
const EventDetailPage = () => {
  const params = useParams();
  const { eventId } = params;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      eventId === "undefined" ||
      eventId === undefined ||
      eventId === null ||
      !eventId
    ) {
      navigate("/");
      return;
    }
  }, [location || eventId]);

  const query = new URLSearchParams(window.location.search);

  const redirectUrl = query.get("redirectUrl");

  return (
    <Layout
      BackAction={redirectUrl}
      Heading="Event Detail"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head"
      CreateHead
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
    >
      <EventDetail />
    </Layout>
  );
};
export default EventDetailPage;
